import { render, staticRenderFns } from "./RetentionsCharts.component.vue?vue&type=template&id=324b7ca4&scoped=true&"
import script from "./RetentionsCharts.component.vue?vue&type=script&lang=js&"
export * from "./RetentionsCharts.component.vue?vue&type=script&lang=js&"
import style0 from "./RetentionsCharts.component.vue?vue&type=style&index=0&id=324b7ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324b7ca4",
  null
  
)

export default component.exports